import axios, { AxiosRequestConfig } from 'axios'
import { ResponseModel } from './models'
import { handleGlobalError, handlePendingRequestMap, handleResponse } from './responseInterceptor'
import { setCommonHeaders, setDebounceRequest, setSafetyVerification } from './requestInterceptor'

const BASE_URL = process.env.REACT_APP_API_URL

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  timeout: 30 * 1000,
})

export interface CustomRequestConfig {
  silent?: boolean
}

export type FetchConfig = Partial<AxiosRequestConfig & CustomRequestConfig>

axiosInstance.interceptors.request.use(setDebounceRequest)
axiosInstance.interceptors.request.use(setSafetyVerification)
axiosInstance.interceptors.request.use(setCommonHeaders)
axiosInstance.interceptors.response.use(handlePendingRequestMap)
axiosInstance.interceptors.response.use(handleResponse, handleGlobalError)

const httpClient = {
  get<T>(url: string, param: object = {}, configs: FetchConfig = {}): Promise<ResponseModel<T>> {
    const fetchConfigs: FetchConfig = {
      method: 'GET',
      url,
      params: param,
      ...configs,
    }
    return this.fetch<T>(fetchConfigs)
  },

  post<T>(url: string, param: object = {}, configs: FetchConfig = {}): Promise<ResponseModel<T>> {
    const fetchConfigs: FetchConfig = {
      method: 'POST',
      url,
      data: param,
      ...configs,
    }
    return this.fetch(fetchConfigs)
  },

  fetch<T>(axiosConfig: FetchConfig): Promise<ResponseModel<T>> {
    return axiosInstance.request(axiosConfig)
  },
}

export default httpClient
